import React, { useState } from "react";
import MaskIcon from "./icons/MaskIcon.jsx";
import UnMaskIcon from "./icons/UnMaskIcon.jsx";
import Input from "./Input.jsx";

const PasswordToggle = ({
  placeholder = "Enter your password",
  ref,
  label,
  error,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="relative w-full">
      <Input
        label={label}
        inputType={showPassword ? "text" : "password"}
        value={password}
        onChange={(e) => {
          setPassword(e.target.value)
        }}
        placeholder={placeholder}
        ref={ref}
        rightIcon={
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="text-gray-600 hover:text-gray-800 focus:outline-none"
          >
            {showPassword ? (
              <MaskIcon className="w-5 h-5" />
            ) : (
              <UnMaskIcon className="w-5 h-5" />
            )}
          </button>
        }
      />
      {error && (
        <p className="text-red-500 text-xs mt-1">{error}</p>
      )}
    </div>
  );
};

export default PasswordToggle;
